<script lang="ts">
    import Banner from "$/components/ui/Banner.svelte";
    import GlobalSearch from "./globalSearch/GlobalSearch.svelte";
    import Logo from "./Logo.svelte";
    import SvgIcon from "./SVGIcon.svelte";
    import NotificationsTray from "./notifications/NotificationsTray.svelte";
    import { ServiceConsts } from "../services/ServiceConsts";
    import { TokenStore } from "../stores/TokenStore.js";
    import { redirect } from "@roxi/routify";
    import { AppStore, Panels } from "$/stores/AppStore";
    import { TenantStore } from "../stores/TenantStore";
    import { slide } from "svelte/transition";
    import { clickAction } from "$/utils/clickAction";
    import { removeSuggestionList } from "./editor/utils";
    import { isMobile } from "$/utils/isMobile";
    import { IntercomUtils } from "$/utils/IntercomUtils";

    export let showMenuIcon = true;

    $: userInitials = generateUserInitials($TokenStore.user);

    // we can use this code to create whitelabel or tenant specific themes
    // but for now we will use the default theme

    // let localTheme;
    // TenantStore.subscribeTheme((theme) => {
    //     localTheme = theme;
    // });

    let primaryColor = "#374151";
    // $: primaryColor = localTheme?.primaryColor || $TenantStore?.active?.theme?.primaryColor || '#374151';

    const generateUserInitials = (user) => {
        if (!user) return "CW";

        const LATIN_LETTERS = /^[a-zA-Z]*$/;
        const getFirstLetter = (name) => name.trim().substring(0, 1);

        // if user has first & last name.
        if (user.firstName && user.lastName) {
            // if both letters are latin letters return them
            if (
                LATIN_LETTERS.test(user.firstName.trim().substring(0, 1)) &&
                LATIN_LETTERS.test(user.lastName.trim().substring(0, 1))
            ) {
                return (
                    getFirstLetter(user.firstName) +
                    getFirstLetter(user.lastName)
                );

                // else return only first name letter because non-latin letters tend to be wider
            } else {
                return getFirstLetter(user.firstName);
            }

            // if user has only first name return first name letter
        } else if (user.firstName) {
            return getFirstLetter(user.firstName);

            // if user has only last name return last name letter
        } else if (user.lastName) {
            return getFirstLetter(user.lastName);

            // else return first letter of the username
        } else {
            return getFirstLetter(user.username);
        }
    };

    const openSidePanel = (panelName) => {
        if ($isMobile) removeSuggestionList();

        AppStore.togglePanel(panelName);

        if ($AppStore.panel === Panels.NONE) {
            IntercomUtils.show();
        } else {
            IntercomUtils.hide();
        }
    };

    $: isOwner = $TenantStore && TenantStore.isOwner($TokenStore?.user?.id);
</script>

<div class="appbar" style="background-color: {primaryColor}">
    {#if showMenuIcon}
        <!-- hamburger icon -->
        <div
            class="hamburger-appbar-menu"
            use:clickAction={() => openSidePanel(Panels.SIDEPANEL)}
        >
            <SvgIcon name="hamburger" color="white" size="20" />
        </div>
    {/if}

    <!-- collabwriting logo -->
    <Logo
        on:click={() => {
            AppStore.closePanels();
            $redirect("/");
        }}
        class="cursor-pointer"
    />

    <div class="appbar-right">
        <GlobalSearch />
        <!-- help button -->
        <a
            class="appbar-right__help"
            href={ServiceConsts.HELP_URL}
            target="_blank"
            rel="noreferrer"
        >
            <SvgIcon name="question-mark-circle" color="white" size="20" />
        </a>

        <NotificationsTray />

        <!-- user initials icon -->
        <a
            class="appbar-right__profile"
            href={"#"}
            on:click={() => openSidePanel(Panels.SETTINGS)}>{userInitials}</a
        >
    </div>
</div>

{#if TenantStore.isExpired() && $TenantStore && $TokenStore}
    <div transition:slide>
        <Banner
            variant="warning"
            message={isOwner
                ? "Oops, your team subscription has expired! Renew now for full access!"
                : "Oops, your team subscription has expired! Contact the workspace owner to renew it!"}
            actionButton={isOwner
                ? {
                      label: "Renew now",
                      onClick: () => $redirect("/payment"),
                  }
                : null}
        />
    </div>
{/if}

<style>
    .appbar {
        @apply z-20 flex h-10 w-full items-center justify-start bg-gray-700 px-4 py-2;
    }

    .hamburger-appbar-menu {
        @apply -ml-1 mr-2 cursor-pointer rounded-md p-1 hover:bg-gray-800 md:hidden;
    }

    .appbar-right {
        @apply ml-auto flex flex-row gap-2;
    }

    .appbar-right__help {
        @apply m-auto;
    }

    .appbar-right__profile {
        @apply my-auto grid h-7 w-7 cursor-pointer select-none place-items-center rounded-full bg-black bg-opacity-40 text-base uppercase text-white;
    }
</style>
